import { useEffect } from "react"
import { css } from "@emotion/react"

export default function Aborter({ abort }) {
    useEffect(() => {
        return () => {
            if (typeof abort === 'function') {
                abort()
            }
        }
    }, [])

    return <div css={css`display: none;`} />
}